module.exports = __webpack_public_path__ + "media/images/sec_5-3-0bc922fa89c2a3b897964f9105281704.png";